import { updateMainClients } from 'stores/slice/bogus/clients/const';

const clientsConfig = {
  // msp > org > site get clients
  "/ents/:entId/orgs/:orgId/sites/:siteId/clients.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/clients",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "clients",
  },
  // org > site > get clients
  "/orgs/:orgId/sites/:siteId/clients.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/clients",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "clients",
  },
  // msp > org > site > update
  "/ents/:entId/orgs/:orgId/sites/:siteId/clients/:clientId/settings.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/clients/:clientId/settings",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateMainClients,
    mockSelector: "clients",
  },
  // org > site > update
  "/orgs/:orgId/sites/:siteId/clients/:clientId/settings.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/clients/:clientId/settings",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateMainClients,
    mockSelector: "clients",
  },
  // msp > org > site get selected client
  "/ents/:entId/orgs/:orgId/sites/:siteId/clients/:clientId/status.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/clients/:clientId/status",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "selectedClient",
  },
  // org > site get selected client
  "/orgs/:orgId/sites/:siteId/clients/:clientId/status.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/clients/:clientId/status",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "selectedClient",
  },
  // msp > org > site get clients statistics
  "/ents/:entId/orgs/:orgId/sites/:siteId/clients/:clientId/stats.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/clients/:clientId/stats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "clientStatistics.statistics",
  },
  // org > site > get clients statistics
  "/orgs/:orgId/sites/:siteId/clients/:clientId/stats.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/clients/:clientId/stats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "clientStatistics.statistics",
  },
};

export default clientsConfig;
